export const fortAwesomeScripts: string[] = [
  'https://use.fortawesome.com/5c2efbbd.js', // VmsIcons font
  'https://use.fortawesome.com/30510c0d.js', // GXIcons font
  'https://use.fortawesome.com/cb6d04c8.js', // New VmsIcons font from ui-kit
]

export function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = true
    script.onload = () => resolve()
    script.onerror = () => {
      reject(new Error(`Script load error for ${src}`))
    }
    document.head.appendChild(script)
  })
}

export function initializeFortAwesome(): Promise<PromiseSettledResult<void>[]> {
  return Promise.allSettled(fortAwesomeScripts.map(loadScript))
}
